import Saida from "./Saida";

export default class SaidaItem {
  constructor(id, codigo, nome, quantidade) {
    this.id = id;
    this.codigo = codigo;
    this.nome = nome;
    this.quantidade = quantidade;
    this.saida = new Saida(0, "", "", new Date(), "", "", "");
  }

  update(item) {
    this.id = item.id;
    this.codigo = item.codigo;
    this.nome = item.nome;
    this.quantidade = item.quantidade;
    this.saida = item.saida;
  }
}